import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        // Status-specific variants with semantic colors and patterns
        active:
          "border-sage-200 bg-sage-100 text-sage-700 hover:bg-sage-200",
        inactive:
          "border-cream-300 bg-cream-50 text-espresso-600 hover:bg-cream-100",
        archived:
          "border-cream-300 bg-cream-100 text-espresso-500 hover:bg-cream-200",
        dissolved:
          "border-error-200 bg-error-50 text-error-700 hover:bg-error-100",
        // Document status variants
        approved:
          "border-sage-200 bg-sage-100 text-sage-700 hover:bg-sage-200",
        published:
          "border-sage-200 bg-sage-100 text-sage-700 hover:bg-sage-200",
        review:
          "border-gold-200 bg-gold-100 text-gold-700 hover:bg-gold-200",
        draft:
          "border-cream-300 bg-cream-200 text-espresso-600 hover:bg-cream-300",
        rejected:
          "border-error-200 bg-error-50 text-error-700 hover:bg-error-100",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export { Badge, badgeVariants }